/**
 * Correlates browser ↔ API ↔ Railway logs. Sent as X-Request-Id on every axios call.
 */
export function createRequestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `rid-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
}
